import React from "react";
import styles from "./Breadcrumb.module.scss";

export const Breadcrumb = ({ trail, onNavigate }) => {
  if (!trail || trail.length < 2) return null;

  return (
    <nav className={styles.breadcrumb} aria-label="Breadcrumb">
      {trail.map((crumb, idx) => {
        const isLast = idx === trail.length - 1;
        return (
          <React.Fragment key={crumb.view}>
            {idx > 0 && (
              <span className={styles.separator} aria-hidden="true">
                ›
              </span>
            )}
            {isLast ? (
              <span className={styles.current} aria-current="page">
                {crumb.label}
              </span>
            ) : (
              <button type="button" className={styles.crumbLink} onClick={() => onNavigate(crumb.view)}>
                {crumb.label}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
